import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface IHediyeCekleri_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHediyeCekleri_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  CGC_VerifyCustomerGetById: any[];
  CGC_VerifyCustomerGetById_dummy: any[];
  GetGiftCards: any;
  GetGiftCards_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp173849Visible: "visible" | "hidden";
  isComp811242Visible: "visible" | "hidden";
  isComp312819Visible: "visible" | "hidden";
  isComp430602Visible: "visible" | "hidden";
  isComp265847Visible: "visible" | "hidden";
  isComp92271Visible: "visible" | "hidden";
  isComp450465Visible: "visible" | "hidden";
  isComp334837Visible: "visible" | "hidden";
  isComp670612Visible: "visible" | "hidden";
  isComp632534Visible: "visible" | "hidden";
  isComp545286Visible: "visible" | "hidden";
  isComp79536Visible: "visible" | "hidden";
}

export class HediyeCekleri_ScreenBase extends React.PureComponent<IHediyeCekleri_ScreenProps, any> {
  hediyecekleri_15422_value_kuikaGalleryViewRef: React.RefObject<any>;
  hediyecekleri_12405_value_kuikaGalleryViewRef: React.RefObject<any>;
  hediyecekleri_616426_value_kuikaGalleryViewRef: React.RefObject<any>;
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "9380f598-924c-4438-82c6-50df1824ec23",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 670427, PropertyName: "value", Value: "Sana Özel Hediyeler" },
        { Id: 15422, PropertyName: "nodatafoundmessage", Value: "No data found." },
        { Id: 704787, PropertyName: "value", Value: "Penti" },
        { Id: 516269, PropertyName: "value", Value: "Son Geçerlilik Tarihi" },
        { Id: 763205, PropertyName: "value", Value: "[datafield:validthru]" },
        { Id: 355974, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 248457, PropertyName: "value", Value: "TL" },
        { Id: 632643, PropertyName: "value", Value: "[datafield:cus_giftcardcode]" },
        { Id: 274934, PropertyName: "value", Value: "Çek kullanım koşulları için" },
        { Id: 619485, PropertyName: "value", Value: "tıklayınız." },
        { Id: 312819, PropertyName: "value", Value: "Hediye Çeki Kullanım süresi dolmuş." },
        { Id: 177680, PropertyName: "value", Value: "[datafield:cus_cuscardnumber]" },
        { Id: 576816, PropertyName: "value", Value: "Gönderici İsmi" },
        { Id: 677445, PropertyName: "value", Value: "[datafield:cus_sendername]" },
        { Id: 315161, PropertyName: "value", Value: "Mesaj" },
        { Id: 831924, PropertyName: "value", Value: "[datafield:cus_messagetext]" },
        { Id: 351162, PropertyName: "value", Value: "Hediye Çeklerim" },
        { Id: 317437, PropertyName: "value", Value: "Girdiğiniz numaraya ait görüntülenecek Aktif Çek yoktur." },
        { Id: 12405, PropertyName: "nodatafoundmessage", Value: "No data found." },
        { Id: 616334, PropertyName: "value", Value: "Penti" },
        { Id: 911239, PropertyName: "value", Value: "Son Geçerlilik Tarihi" },
        { Id: 517910, PropertyName: "value", Value: "[datafield:validthru]" },
        { Id: 361151, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 935245, PropertyName: "value", Value: "TL" },
        { Id: 306806, PropertyName: "value", Value: "[datafield:groupdescription]" },
        { Id: 792951, PropertyName: "value", Value: "[datafield:code]" },
        { Id: 434444, PropertyName: "value", Value: "Çek kullanım koşulları için" },
        { Id: 813028, PropertyName: "value", Value: "tıklayınız." },
        { Id: 334837, PropertyName: "value", Value: "Hediye Çeki Kullanım süresi dolmuş." },
        { Id: 670612, PropertyName: "label", Value: "Hediye Bilgilerini Gör" },
        { Id: 632534, PropertyName: "label", Value: "Hediye Gönder" },
        { Id: 537379, PropertyName: "value", Value: "Pasif Hediye Çekleri" },
        { Id: 616426, PropertyName: "nodatafoundmessage", Value: "No data found." },
        { Id: 769504, PropertyName: "value", Value: "Penti" },
        { Id: 74832, PropertyName: "value", Value: "Son Geçerlilik Tarihi" },
        { Id: 766115, PropertyName: "value", Value: "[datafield:validthru]" },
        { Id: 31489, PropertyName: "value", Value: "[datafield:code]" },
        { Id: 730948, PropertyName: "value", Value: "[datafield:statustext]" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.hediyecekleri_15422_value_kuikaGalleryViewRef = React.createRef();
    this.hediyecekleri_12405_value_kuikaGalleryViewRef = React.createRef();
    this.hediyecekleri_616426_value_kuikaGalleryViewRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      CGC_VerifyCustomerGetById: [],
      GetGiftCards: "",
      Notify: false,
      NAVIGATE: "",
      isComp173849Visible: "hidden",
      isComp811242Visible: "hidden",
      isComp312819Visible: "hidden",
      isComp430602Visible: "hidden",
      isComp265847Visible: "hidden",
      isComp92271Visible: "hidden",
      isComp450465Visible: "hidden",
      isComp334837Visible: "hidden",
      isComp670612Visible: "hidden",
      isComp632534Visible: "hidden",
      isComp545286Visible: "hidden",
      isComp79536Visible: "hidden"
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("hediyecekleri", "");
      return;
    }

    if (true) {
      await this.HediyeCekleriPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hediyecekleri", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hediyecekleri", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HediyeCekleriPageInit();
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  HediyeCekleriPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.VerifyCustomerId ?? this.props.screenInputs.verifycustomerid,
        "Guid"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "HediyeCekleri/HediyeCekleriPageInit", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.CGC_VerifyCustomerGetById = result?.data.cgC_VerifyCustomerGetById;
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HediyeCekleriPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HediyeCekleriPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    let localVar = {
      CusCardNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].cusCardNumber
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].cusCardNumber
            : null
        ),
        "string"
      )
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(this, "HediyeCekleri/HediyeCekleriPageInit1_", localVar);
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetGiftCards = result?.data.getGiftCards;

      stateVars.isComp173849Visible =
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(this, stateVars.GetGiftCards?.cusGiftedCardsCount),
          "0"
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp430602Visible =
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(this, stateVars.GetGiftCards?.validGiftCardsCount),
          "0"
        ) === true
          ? "visible"
          : "hidden";
      stateVars.isComp545286Visible =
        ReactSystemFunctions.isGreaterThan(
          ReactSystemFunctions.value(this, stateVars.GetGiftCards?.inValidGiftCardsCount),
          "0"
        ) === true
          ? "visible"
          : "hidden";
      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HediyeCekleriPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "0"
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "986d0beb_4c57_df7d_37a8_e4f222ef3811_notify",
          this.defaultML,
          "Süre aşımından dolayı müşteri doğrulama sayfasına yönlendiriliyorsunuz."
        ),
        "info",
        "bottom-right",
        0,
        "",
        "",
        0
      );

      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "0"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.HediyeCekleriPageInit4_,
        "HediyeCekleri",
        "Welcome",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true
      );

      this.props.form.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.isComp173849Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(this, this.state.GetGiftCards?.cusGiftedCardsCount),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HediyeCekleriPageInit5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HediyeCekleriPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      stateVars.dataSource_15422 = this.state.GetGiftCards.cusGiftedCards;

      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.isComp811242Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_15422_value", "isGiftCardValid"),
        true
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp312819Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_15422_value", "isGiftCardValid"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp430602Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.GetGiftCards?.validGiftCardsCount),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HediyeCekleriPageInit8_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HediyeCekleriPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      stateVars.dataSource_12405 = this.state.GetGiftCards.validGiftCards;

      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.isComp265847Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGiftCardValid"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp92271Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGifted"),
        false
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp450465Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGifted"),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp334837Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGiftCardValid"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp670612Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGifted"),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp632534Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "isGifted"),
        false
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp545286Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(this, this.state.GetGiftCards?.inValidGiftCardsCount),
        "0"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HediyeCekleriPageInit11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  HediyeCekleriPageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      this.props.form.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.HediyeCekleriPageInit12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  HediyeCekleriPageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.CGC_VerifyCustomerGetById?.length > 0
            ? stateVars.CGC_VerifyCustomerGetById[0].isOnTime
            : this.state.CGC_VerifyCustomerGetById?.length > 0
            ? this.state.CGC_VerifyCustomerGetById[0].isOnTime
            : null
        ),
        "1"
      )
    ) {
      stateVars.dataSource_616426 = this.state.GetGiftCards.inValidGiftCards;

      this.props.form.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HediyeCekleriComponent_619485_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TermsOfUse",
      "ValidThrough",
      ReactSystemFunctions.value(this, "hediyecekleri_15422_value", "cus_GiftCardValidThrough")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HediyeCekleri",
      "TermsOfUse",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "858142",
      null,
      "bottom",
      null,
      "100%",
      "90vh",
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HediyeCekleriComponent_813028_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TermsOfUse",
      "ValidThrough",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "validThroughText")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HediyeCekleri",
      "TermsOfUse",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "26146",
      null,
      "bottom",
      null,
      "100%",
      "90vh",
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HediyeCekleriComponent_670612_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "Id",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "cus_Id")
    );
    KuikaAppManager.addToPageInputVariables("SendAsGift", "CusCardNumber", null);
    KuikaAppManager.addToPageInputVariables("SendAsGift", "Code", null);
    KuikaAppManager.addToPageInputVariables("SendAsGift", "ValidThroughText", null);
    KuikaAppManager.addToPageInputVariables("SendAsGift", "ValidThru", null);

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HediyeCekleri",
      "SendAsGift",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "697681",
      null,
      "right",
      null,
      "380px",
      "100vh",
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HediyeCekleriComponent_632534_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "Id",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "cus_Id")
    );
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "CusCardNumber",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "customerCardNumber")
    );
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "Code",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "code")
    );
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "ValidThroughText",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "validThroughText")
    );
    KuikaAppManager.addToPageInputVariables(
      "SendAsGift",
      "ValidThru",
      ReactSystemFunctions.value(this, "hediyecekleri_12405_value", "validThru")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "HediyeCekleri",
      "SendAsGift",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "407669",
      null,
      "right",
      null,
      "380px",
      "100vh",
      true
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HediyeCekleriComponent_753487_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HediyeCekleriComponent_92271_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 858142, 26146, 697681, 407669] as number[];
    if (window.kuika?.serverRequestCount > 0 && pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HediyeCekleriPageInit();
    }
  }
}
